/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const PencilLine = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M12 20h9" }],
    ["path", { d: "M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" }],
    ["path", { d: "m15 5 3 3" }]
  ]
];

export { PencilLine as default };
//# sourceMappingURL=pencil-line.js.map
